"use client"

import { RouteErrorBoundary } from "@/components/shared/route-error-boundary"

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      boundary="app/error.tsx"
      title="Something went wrong"
      description="We encountered an unexpected error"
      action="home"
      footer="If this problem persists, please contact support."
    />
  )
}
